var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 27,
    viewBox: "0 0 26 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.9167 0.75C23.6681 0.75 24.3888 1.04851 24.9201 1.57986C25.4515 2.11122 25.75 2.83189 25.75 3.58333V23.4167C25.75 24.1681 25.4515 24.8888 24.9201 25.4201C24.3888 25.9515 23.6681 26.25 22.9167 26.25H3.08333C2.33189 26.25 1.61122 25.9515 1.07986 25.4201C0.548511 24.8888 0.25 24.1681 0.25 23.4167V3.58333C0.25 2.83189 0.548511 2.11122 1.07986 1.57986C1.61122 1.04851 2.33189 0.75 3.08333 0.75H22.9167ZM22.2083 22.7083V15.2C22.2083 13.9751 21.7218 12.8005 20.8557 11.9343C19.9895 11.0682 18.8149 10.5817 17.59 10.5817C16.3858 10.5817 14.9833 11.3183 14.3033 12.4233V10.8508H10.3508V22.7083H14.3033V15.7242C14.3033 14.6333 15.1817 13.7408 16.2725 13.7408C16.7985 13.7408 17.303 13.9498 17.6749 14.3217C18.0469 14.6937 18.2558 15.1982 18.2558 15.7242V22.7083H22.2083ZM5.74667 8.62667C6.37788 8.62667 6.98324 8.37592 7.42958 7.92958C7.87592 7.48324 8.12667 6.87788 8.12667 6.24667C8.12667 4.92917 7.06417 3.8525 5.74667 3.8525C5.11169 3.8525 4.50273 4.10474 4.05374 4.55374C3.60474 5.00273 3.3525 5.61169 3.3525 6.24667C3.3525 7.56417 4.42917 8.62667 5.74667 8.62667ZM7.71583 22.7083V10.8508H3.79167V22.7083H7.71583Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIn);
export default __webpack_public_path__ + "static/media/in.3d28cb3fcc2066c08fea3e6704441b64.svg";
export { ForwardRef as ReactComponent };